import { render } from "./bidding-component.vue?vue&type=template&id=7c0238d5&ts=true"
import script from "./bidding-component.vue?vue&type=script&lang=ts"
export * from "./bidding-component.vue?vue&type=script&lang=ts"

import "./bidding-component.vue?vue&type=style&index=0&id=7c0238d5&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__